export const generateSVgHover = (slug?: string) => {
  switch (slug) {
    case 'success': {
      return 'group-hover:text-success'
    }
    case 'primary': {
      return 'group-hover:text-primary'
    }
    case 'secondary': {
      return 'group-hover:text-secondary'
    }
    case 'warning': {
      return 'group-hover:text-warning'
    }
    default: {
      return ''
    }
  }
}
